import { apiRequest } from '../../api/client';
import { getApiToken } from '../../api/authToken';

export async function getEmailChangeCooldown() {
  const token = await getApiToken();
  return apiRequest('/api/auth/email-change/cooldown', { token });
}

export async function requestEmailChange() {
  const token = await getApiToken();
  return apiRequest('/api/auth/email-change/request', {
    token,
    method: 'POST',
    body: {},
  });
}
